import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  createCriteria,
  updateCriteria,
} from "../../features/admin/CriteriaSlice";
import { toast } from "react-toastify";

const criteriaSchema = Yup.object().shape({
  key: Yup.string().trim().required("Mã tiêu chí không được để trống"),
  name: Yup.string().trim().required("Tên tiêu chí không được để trống"),
  point: Yup.number().required("Điểm không được để trống"),
});

const fieldLabels = {
  key: "Mã tiêu chí",
  name: "Tên tiêu chí",
  point: "Điểm tiêu chí",
};

const CriteriaModal = ({ criteria, onClose }) => {
  const [formData, setFormData] = useState({
    key: "",
    name: "",
    point: null,
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    if (criteria) {
      setFormData(criteria);
    }
  }, [criteria]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await criteriaSchema.validate(formData, { abortEarly: false });
      if (criteria) {
        await dispatch(
          updateCriteria({ id: criteria.id, newPost: formData })
        ).unwrap();
        toast.success("Cập nhật thành công!");
        onClose();
      } else {
        await dispatch(createCriteria(formData)).unwrap();
        toast.success("Thêm mới thành công!");
        onClose();
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const formErrors = {};
        error.inner.forEach((err) => {
          formErrors[err.path] = err.message;
        });
        setErrors(formErrors);
      } else {
        toast.error(error.messages);
        console.error("Lỗi khi lưu tiêu chí:", error);
      }
    }
  };
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
      <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold ">
              {criteria ? "Chỉnh sửa thông tin tiêu chí" : "Thêm mã tiêu chí"}
            </h2>
            <button
              onClick={onClose}
              className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
            >
              X
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="flex gap-10 mb-5">
              <div className="w-full">
                <label className="block text-sm font-medium mb-1">
                  {fieldLabels.key}
                  <i className="text-red-600"> *</i>
                </label>
                <input
                  disabled={criteria != null}
                  type="text"
                  name={formData.key}
                  value={formData.key}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      key: e.target.value,
                    });
                    setErrors({ ...errors, key: "" });
                  }}
                  className={`w-full p-2 border rounded-md ${
                    errors.key ? "border-red-500" : "border-gray-300"
                  } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                />
                {errors.key && (
                  <p className="mt-1 text-sm text-red-600">{errors.key}</p>
                )}
              </div>
              <div className="w-full">
                <label className="block text-sm font-medium mb-1">
                  {fieldLabels.name}
                  <i className="text-red-600"> *</i>
                </label>
                <input
                  disabled={criteria?.type === "auto"}
                  type="text"
                  name={formData.name}
                  value={formData.name}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    });
                    setErrors({ ...errors, name: "" });
                  }}
                  className={`w-full p-2 border rounded-md ${
                    errors.name ? "border-red-500" : "border-gray-300"
                  } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-600">{errors.name}</p>
                )}
              </div>
            </div>
            <div className="flex gap-10 mb-5">
              <div className="w-full">
                <label className="block text-sm font-medium  mb-1">
                  {fieldLabels.point}
                  <i className="text-red-600"> *</i>
                </label>
                <input
                  type="number"
                  name={formData.point}
                  value={formData.point}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      point: Number(e.target.value),
                    });
                    setErrors({ ...errors, point: "" });
                  }}
                  className={`w-full p-2 border rounded-md ${
                    errors.point ? "border-red-500" : "border-gray-300"
                  } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                />
                {errors.point && (
                  <p className="mt-1 text-sm text-red-600">{errors.point}</p>
                )}
              </div>
              <div className="w-full"></div>
            </div>

            {/* Footer - Action Buttons */}
            <div className="flex justify-end space-x-4 pt-4 border-t">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                Hủy
              </button>
              <button
                type="submit"
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              >
                {criteria ? "Cập nhật" : "Thêm mới"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CriteriaModal;
